import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetButtonActions } from './useGetButtonActions'
import { ButtonActionsContent } from './ButtonActionsContent'

export const ButtonActionsComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetButtonActions(id, tileFilterSelections)

  return (
    <ButtonActionsContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
    />
  )
}

export function ButtonActionsComponentLoading() {
  return 'Loading...'
}
